export const MODULES_CREATE = '/modules/create'
